import {useMutation} from "@tanstack/react-query";

import {removeMaterialNoteMutationOptions} from "./remove-material-note.mutation-options";

export function useRemoveMaterialNote(id: string) {
  return useMutation(removeMaterialNoteMutationOptions(id));
}
